import {
  fetchData,
  urls,
} from '@internal/backstage-plugin-dh-dock-shared-common';

export const getYamlContents = async (url: string) => {
  return fetchData(`${urls.yamlValidator}${url}`);
};

export const getMarkDownPreview = async (url: string) => {
  return fetchData(`${urls.previewMarkDown}${encodeURIComponent(url)}`);
};
